import { faBars, faCog } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Nav, NavItem, Navbar } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import Common from '../../common/Common'
import Themes from '../../themes/Themes'
import Logout from '../../auth/Logout'
import UserMenuItem from './items/UserMenuItem'
import InnerSearchMenuItem from './items/InnerSearchMenuItem'
import OuterSearchMenuItem from './items/OuterSearchMenuItem'
import NotificationsMenuItem from './items/NotificationsMenuItem'
import { toggleSideNav } from '../../../features/settings/settings.slice'
import { useEffect, useState } from 'react'
// import AlertsMenuItem from './items/AlertsMenuItem'

const Topbar: React.FC = () => {
    const theme = useAppSelector((state) => state.theme.theme)
    const sideNavToggled = useAppSelector(
        (state) => state.settings.sideNav.toggled
    )
    const topNavFixed: boolean = useAppSelector(
        (state) => state.settings.topNav.fixed
    )

    const [optionalProps, setOptionalProps] = useState({})

    const dispatch = useAppDispatch()

    useEffect(() => {
        if (topNavFixed) {
            setOptionalProps({ fixed: 'top' })
        } else {
            setOptionalProps({})
        }
    }, [topNavFixed])

    return (
        <>
            <Navbar
                className={`topbar shadow border-1${
                    topNavFixed ? ' topNav-fixed' : ''
                }${sideNavToggled ? ' sideNav-shrunk' : ' sideNav-expanded'}`}
                bg={theme === 'dark' ? 'dark' : 'white'}
                {...optionalProps}
            >
                <Button
                    variant={theme === 'dark' ? 'dark' : 'light'}
                    className="d-md-none rounded-circle mx-3"
                    onClick={() => dispatch(toggleSideNav(!sideNavToggled))}
                >
                    <FontAwesomeIcon icon={faBars} />
                </Button>
                <OuterSearchMenuItem />
                <Nav className="ms-auto navbar-nav">
                    <InnerSearchMenuItem />
                    {/* <AlertsMenuItem /> */}
                    <NotificationsMenuItem />
                    <div className="topbar-divider d-none d-sm-block" />
                    <NavItem>
                        <Common.AppSettings
                            title="Settings"
                            trigger={{
                                type: 'a',
                                title: <FontAwesomeIcon icon={faCog} />,
                            }}
                        />
                    </NavItem>
                    <NavItem className="text-warning">
                        <Themes
                            type="link"
                            icon="fa-solid fa-moon"
                            altIcon="fa-regular fa-sun text-white"
                            altThemeName="dark"
                        />
                    </NavItem>
                    <div className="topbar-divider d-none d-sm-block" />
                    <UserMenuItem />
                    <NavItem>
                        <Logout />
                    </NavItem>
                </Nav>
            </Navbar>
        </>
    )
}

export default Topbar
